import { render, staticRenderFns } from "./MenuOptionsNavigation.vue?vue&type=template&id=284a9224&scoped=true"
import script from "./MenuOptionsNavigation.vue?vue&type=script&lang=js"
export * from "./MenuOptionsNavigation.vue?vue&type=script&lang=js"
import style0 from "./MenuOptionsNavigation.vue?vue&type=style&index=0&id=284a9224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a9224",
  null
  
)

export default component.exports